<template>
  <a
    :href="url"
    :target="isExternal ? '_blank' : undefined"
    :rel="isExternal ? 'noopener noreferrer' : undefined"
  >
    <span v-if="isExternal" class="a-visually-hidden">Externer Link:</span>
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      default: 'internal',
    },
  },
  computed: {
    isExternal() {
      return this.target === 'external';
    },
  },
};
</script>
